export function isValidIanaTimeZone(value) {
    try {
        new Intl.DateTimeFormat("en-US", { timeZone: value }).format(new Date(0));
        return value.includes("/") || value === "UTC";
    }
    catch {
        return false;
    }
}
function partsAt(instant, timeZone) {
    const parts = new Intl.DateTimeFormat("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" }).formatToParts(instant);
    const value = (type) => Number(parts.find((part) => part.type === type)?.value ?? 0);
    return { year: value("year"), month: value("month"), day: value("day"), hour: value("hour"), minute: value("minute"), second: value("second") };
}
function parseLocal(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value.trim());
    if (!match)
        throw new Error("Fecha y hora local inválida");
    const parts = { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]), hour: Number(match[4]), minute: Number(match[5]), second: Number(match[6] ?? 0) };
    const probe = new Date(Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second));
    if (probe.getUTCFullYear() !== parts.year || probe.getUTCMonth() !== parts.month - 1 || probe.getUTCDate() !== parts.day || parts.hour > 23 || parts.minute > 59 || parts.second > 59)
        throw new Error("Fecha y hora local inválida");
    return parts;
}
function sameParts(left, right) {
    return left.year === right.year && left.month === right.month && left.day === right.day && left.hour === right.hour && left.minute === right.minute && left.second === right.second;
}
function offsetAt(epochMs, timeZone) {
    const parts = partsAt(new Date(epochMs), timeZone);
    return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) - Math.floor(epochMs / 1000) * 1000;
}
export function zonedDateTimeLocalToUtc(value, timeZone) {
    if (!isValidIanaTimeZone(timeZone))
        throw new Error("Zona horaria IANA inválida");
    const desired = parseLocal(value);
    const wallClockMs = Date.UTC(desired.year, desired.month - 1, desired.day, desired.hour, desired.minute, desired.second);
    const offsets = new Set([offsetAt(wallClockMs - 36 * 60 * 60_000, timeZone), offsetAt(wallClockMs, timeZone), offsetAt(wallClockMs + 36 * 60 * 60_000, timeZone)]);
    const candidates = [...offsets].map((offset) => new Date(wallClockMs - offset)).filter((candidate) => sameParts(partsAt(candidate, timeZone), desired)).sort((left, right) => left.getTime() - right.getTime());
    if (!candidates.length)
        throw new Error("La hora local no existe en esa zona por un cambio horario");
    return candidates[0].toISOString();
}
export function utcToZonedDateTimeLocal(value, timeZone) {
    if (!value)
        return "";
    if (!isValidIanaTimeZone(timeZone))
        throw new Error("Zona horaria IANA inválida");
    const instant = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(instant.getTime()))
        throw new Error("Fecha inválida");
    const parts = partsAt(instant, timeZone);
    const two = (number) => String(number).padStart(2, "0");
    return `${parts.year}-${two(parts.month)}-${two(parts.day)}T${two(parts.hour)}:${two(parts.minute)}`;
}
export function supportedIanaTimeZones() {
    const supportedValuesOf = Intl.supportedValuesOf;
    return supportedValuesOf ? supportedValuesOf("timeZone") : ["America/Argentina/Buenos_Aires", "America/Asuncion", "America/New_York", "Europe/Madrid", "UTC"];
}
